import { InMemoryCache } from '@apollo/client/core';
import { StrictTypedTypePolicies } from '@/generated/apollo-helper';

const typePolicies: StrictTypedTypePolicies = {
  Metadata: {
    merge(existing, incoming, { mergeObjects }) {
      return mergeObjects(existing, incoming);
    },
  },
  AppointmentMessage: {
    keyFields: ['videoId'],
  },
  User: {
    keyFields: ['id'],
    fields: {
      metadata: {
        merge(existing = [], incoming) {
          if (!incoming) return existing;
          return incoming;
        },
      },
    },
  },
  ChatResults: {
    keyFields: ['room_id'],
    fields: {
      count: {
        merge(existing = 0, incoming) {
          return existing + incoming;
        },
      },
      chats: {
        merge(existing = [], incoming, { readField }) {
          const merged = existing ? [...existing] : [];
          incoming.forEach((chatRef) => {
            const id = readField<string>('id', chatRef);
            if (!id) return;
            if (merged.find((ref) => readField('id', ref) === id)) return;
            merged.push(chatRef);
          });

          merged.sort((a, b) => {
            const aCreatedAt = new Date(readField<string>('created_at', a));
            const bCreatedAt = new Date(readField<string>('created_at', b));
            return bCreatedAt.getTime() - aCreatedAt.getTime();
          });

          return merged;
        },
      },
    },
  },
  ChatStatus: {
    keyFields: false,
  },
  Room: {
    keyFields: ['id'],
  },
  Chat: {
    keyFields: ['id'],
    fields: {
      status: {
        merge(existing = [], incoming) {
          if (!incoming) return existing;
          return incoming;
        },
      },
    },
  },
};

export default new InMemoryCache({
  typePolicies,
});
